"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    youAreLost: {
        en: "Hey {name}, it seems that the page you are looking for does not exist!",
        es: "¡Hey {name}, parece que la página que buscas no existe!",
    },
    noRolesAssign: {
        en: "Hey {name}, it seems that you do not have permissions yet, please contact your service provider!",
        es: "¡Hola {name}, parece que todavía no tiene permisos, por favor contacte al proveedor de servicios!",
    },
    youAreNotAuthorized: {
        en: "Sorry {name}, you do not have the necessary permissions to perform this action.",
        es: "¡Lo sentimos {name}, no tienes los permisos necesarios para realizar esta acción.",
    },
    confirmPassword: {
        en: "Both passwords you enter are inconsistent!",
        es: "Las Contraseñas no coinciden!",
    },
    serverError: {
        en: "The action could not be performed, please try again later.",
        es: "No se pudo realizar la acción, por favor intentar más tarde.",
    },
    commonError: {
        en: "Something went wrong, please try again later.",
        es: "Algo malo paso, por favor intentar más tarde.",
    },
    commonSendCommandError: {
        en: "Something went wrong when sending a command, please try again later.",
        es: "Algo malo paso al enviar el comando, por favor intentar más tarde.",
    },
    fetchingDevicesError: {
        en: "Something went wrong fetching the data, please try again.",
        es: "Algo salió mal al cargar los datos, por favor intentar de nuevo.",
    },
    activeSimError: {
        en: "Something went wrong activating line, please try again.",
        es: "Algo salió mal al activar la linea, por favor intentar de nuevo.",
    },
    deactivateSimError: {
        en: "Something went wrong deactivating line, please try again.",
        es: "Algo salió mal al desactivar la linea, por favor intentar de nuevo.",
    },
    nameError: {
        en: "The name is empty.",
        es: "El nombre es requerido.",
    },
    keyError: {
        en: "The key is empty.",
        es: "La llave es requerida.",
    },
    usernameError: {
        en: "The username can contains letters, numbers and the following symbols: _ , @",
        es: "El usuario puede contener letras, números y los siguientes símbolos: _ , @",
    },
    usernameRequired: {
        en: "The username is empty",
        es: "El usuario es requerido",
    },
    consumptionRequired: {
        en: "The minimum consumption is required",
        es: "El consumo mínimo es requerido",
    },
    fillingRequired: {
        en: "The minimum filling is required",
        es: "El llenado mínimo es requerido",
    },
    emailError: {
        en: "The email is misspelled.",
        es: "El correo electrónico está mal escrito.",
    },
    emailRequired: {
        en: "The email is required",
        es: "El correo es requerido",
    },
    passwordError: {
        en: "The password is empty or misspelled.",
        es: "El formato de la contraseña no es el requerido",
    },
    passwordRequired: {
        en: "The password is required",
        es: "La contraseña es requerida",
    },
    passwordResetError: {
        en: "Something went wrong changing the password.",
        es: "Algo salió mal cambiando la contraseña.",
    },
    addressError: {
        en: "The address is empty.",
        es: "La dirección es requerida.",
    },
    contactNameError: {
        en: "The contact name is empty.",
        es: "El nombre de contacto es requerido.",
    },
    clientError: {
        en: "The client is empty.",
        es: "El cliente esta vacío.",
    },
    imeiExitsError: {
        en: "Imei already exits.",
        es: "El icono esta vacío.",
    },
    iconError: {
        en: "The icon is empty.",
        es: "El id esta vacío.",
    },
    pinError: {
        en: "The id is empty.",
        es: "La descripción esta vacía.",
    },
    descriptionError: {
        en: "The description is empty.",
        es: "Contenido no encontrado.",
    },
    notFoundContent: {
        en: "Content not found.",
        es: "No se encontró contenido.",
    },
    resultsNotFound: {
        en: "Results not found.",
        es: "No se encontraron resultados.",
    },
    unknownData: {
        en: 'Unknown',
        es: 'Desconocido'
    },
    imeiError: {
        en: "The imei only can contain numbers and must be composed by 15 digits.",
        es: "El imei solo puede contener números y debe ser de 15 dígitos.",
    },
    portFormatError: {
        en: "The port only can contain number.",
        es: "El puerto solo puede contener números.",
    },
    pinFormatError: {
        en: "The id must be start with an number or letter and only can contain dashes, numbers and letters.",
        es: "El id debe comenzar con un numero o letra y solo puede contener guiones, números y letras",
    },
    descriptionLengthError: {
        en: "The description cannot be longer than 45 characters",
        es: "La descripción no puede ser mas larga de 45 caracteres",
    },
    dataPortError: {
        en: "The port is empty.",
        es: "El puerto está vacío.",
    },
    deviceModelError: {
        en: "The model is empty.",
        es: "El modelo está vacío.",
    },
    modelProfileError: {
        en: "The profile is empty.",
        es: "El perfil está vacío.",
    },
    firmwareVersionError: {
        en: "The firmware is empty.",
        es: "El firmware esta vacío.",
    },
    lineRequired: {
        en: "The Line is empty.",
        es: "La línea esta vacía.",
    },
    lineError: {
        en: "The line number is invalid.",
        es: "El número de la línea no es válido.",
    },
    iccidEidError: {
        en: "The iccid or eid number is invalid.",
        es: "El iccid o eid no es válido.",
    },
    iccidError: {
        en: "ICCID is invalid, iccid should be between 18 and 20 numbers.",
        es: "ICCID no es válido, el iccid debe estar entre 18 y 20 números.",
    },
    eidError: {
        en: "EID is invalid, eid should be of 32 numbers.",
        es: "EID no es válido, el eid de constar de 32 números.",
    },
    serialError: {
        en: "The serial is misspelled",
        es: "El serial esta mal escrito",
    },
    deleteCarrierError: {
        en: "Cannot delete this carrier because it's been assigned to a sim",
        es: "No se puede eliminar el proveedor porqué esta asignado a una sim",
    },
    conectionError: {
        en: "Your connection with the server has been interrupted, please",
        es: "Tu conexión con el servidor a sido interrumpida, por favor",
    },
    tryAgain: {
        en: "try again.",
        es: "intente de nuevo.",
    },
    reconecting: {
        en: "Trying to communicate with server.",
        es: "Estableciendo comunicación con el servidor.",
    },
    timeZoneError: {
        en: "The time zone is empty.",
        es: "La zona horaria esta vacía.",
    },
    sensorsError: {
        en: "There are no sensors installed, please contact your service provider.",
        es: "No hay sensores instalados, por favor contacte su proveedor de servicio.",
    },
    usernameAlreadyExist: {
        en: "User Already Exist.",
        es: "El usuario ya esta en uso.",
    },
    disableUser: {
        en: "Error while trying to disable user.",
        es: "Error al inhabilitar el usuario.",
    },
    emailAlreadyExist: {
        en: "Email Already Exist.",
        es: "El correo ya esta en uso.",
    },
    maximunSize: {
        en: "Maximum text length: {number}",
        es: "Longitud máxima: {number}",
    },
    minimunSize: {
        en: "Minimum text length: {number}",
        es: "Longitud mínima: {number}",
    },
    isRequired: {
        en: "The field is required",
        es: "El campo es requerido",
    },
    whitespaceNotAllowed: {
        en: "Whitespace are not allowed",
        es: "Los espacios en blanco no son permitidos.",
    },
    sharedGroup: {
        en: "You can't share a group with a shared device.",
        es: "No puedes compartir un grupo con dispositivos que no te pertenecen.",
    },
    modelSendTypeError: {
        en: "The model send type is empty.",
        es: "El método de envío es requerido",
    },
    brandError: {
        en: "The brand is empty.",
        es: "La marca es requerida.",
    },
    emailValid: {
        en: "Not a valid email.",
        es: "Correo no valido.",
    },
    phoneValid: {
        en: "Not a valid phone number.",
        es: "Teléfono no valido.",
    },
    selectDate: {
        en: "The date is empty.",
        es: "La fecha es requerida",
    },
    selectDistance: {
        en: "The distance is required.",
        es: "La distancia es requerida",
    },
    selectHours: {
        en: "The hour is required.",
        es: "La hora es requerida",
    },
    assignToError: {
        en: "Assign to is required.",
        es: "Asignar a es requerido.",
    },
    selectDevicesError: {
        en: "You must select at least one unit",
        es: "Debe seleccionar por lo menos una unidad",
    },
    serviceError: {
        en: "Something went wrong, please check the service information you provided.",
        es: "Algo no esta bien, por favor revisar la información ingresada del servicio.",
    },
    apiKeyError: {
        en: "Something went wrong, the api key is invalid please check.",
        es: "Algo no esta bien, la api key es invalida, por favor verifique.",
    },
    linkError: {
        en: "The link you are using is no longer valid!",
        es: "¡El enlace que está utilizando ya no es válido!",
    },
    selectClient: {
        en: "Please select a client",
        es: "Por favor seleccione un cliente",
    },
    deletePartial: {
        en: "Not all models were deleted, you can't delete models assigned to a unit.",
        es: "No todos los modelos se eliminaron, no puedes eliminar un modelo asignado a una unidad.",
    },
    deleteProfileError: {
        en: "You can't delete a profile assigned to a unit.",
        es: "No puedes eliminar un perfil asignado a una unidad.",
    },
    sharedDevicesExternalError: {
        en: "Something went wrong sharing units.",
        es: "Algo salió mal compartiendo unidades.",
    },
    sharedDevicesEmailsError: {
        en: "You must provide emails to share units.",
        es: "Debe proporcionar correos electrónicos para compartir unidades.",
    },
    sharedDevicesPhonesError: {
        en: "You must provide phone numbers to share units.",
        es: "Debe proporcionar números de teléfono para compartir unidades.",
    },
    sharedDevicesServiceError: {
        en: "You don't have any messaging service active to share units.",
        es: "No tiene ningún servicio de mensajería activado para compartir unidades.",
    },
    noTranslation: {
        en: "No description",
        es: "No hay descripción",
    },
    NoPoiSelectedError: {
        en: "You have to select at least 1 points of interests.",
        es: "Tienes que elegir al menos 1 punto de interés.",
    },
    valueError: {
        en: "The value is required",
        es: "El valor es requerido",
    },
    erequest: {
        en: "El Campo {field} puede estar incorrecto o duplicado.",
        es: "The {field} field may be incorrect or duplicated.",
    },
    noServiceActive: {
        en: "Error while trying to send verification email, no email service active.",
        es: "Error al enviar correo de verificación, servicio de correos no activo.",
    },
    serviceTypeNotFound: {
        en: "Error while trying to send verification email, email service type not found.",
        es: "Error al enviar correo de verificación, tipo de servicio de correos no encontrado.",
    },
    optionsError: {
        en: "Error while trying to send verification email.",
        es: "Error al enviar correo de verificación.",
    },
    emptyTank: {
        en: "No client/unit selected",
        es: "No hay cliente/unidad seleccionado",
    },
    lengthRequired: {
        en: "The length is required",
        es: "El largo es requerido",
    },
    widthRequired: {
        en: "The width is required",
        es: "El ancho es requerido",
    },
    heightRequired: {
        en: "The height is required",
        es: "El alto es requerido",
    },
    diameterRequired: {
        en: "The diameter is required",
        es: "El diámetro es requerido",
    },
    minRequired: {
        en: "The min is required",
        es: "El min es requerido",
    },
    maxRequired: {
        en: "The max is required",
        es: "El max es requerido",
    },
    formulaRequired: {
        en: "The formula is required",
        es: "La fórmula es requerida",
    },
    lineDuplicatedError: {
        en: "The line is duplicated.",
        es: "La linea está duplicada.",
    },
    invalidTankFormula: {
        en: "The formula is invalid",
        es: "La fórmula es invalida",
    },
    successTags: {
        en: "{tag, plural, =0 {# Tags} one {# Tag} other {# Tags}} deleted.",
        es: "{tag, plural, one {# Etiqueta eliminada} other {# Etiquetas eliminadas}}.",
    },
    noTagsSelected: {
        en: "You must select one tag or more before you try to delete.",
        es: "Debes seleccionar una etiqueta o mas antes de intentar eliminar.",
    },
    deleteTags: {
        en: "{tag, plural, =0 {# Tags not deleted} one {# Tag not deleted} other {# Tags not deleted}}.",
        es: "{tag, plural, one {# Etiqueta no fue eliminada} other {# Etiquetas no fueron eliminadas}}.",
    },
    cantDeleteTags: {
        en: "The following selected tags can't be deleted because they are being used in schedules or assigned to a point of interest.",
        es: "Las siguientes etiquetas seleccionadas no pueden ser eliminadas porque están siendo utilizadas en una ruta o están asignadas a un punto de interés.",
    },
    cantAddDuplicates: {
        en: "You can't add duplicate items",
        es: "No puedes agregar elementos duplicados",
    },
    phoneAddError: {
        en: "There was a problem with the following numbers: {phoneList}",
        es: "Hubo un problema con los siguientes números: {phoneList}",
    },
    emailAddError: {
        en: "There was a problem with the following emails: {emailList}",
        es: "Hubo un problema con los siguientes correos: {emailList}",
    },
    sizeAndTypeImageError: {
        en: "Image must be of type PNG or JPG and must not exceed 2mb.",
        es: "El formato de la imagen debe ser PNG o JPG y no debe pesar mas de 2mb.",
    },
    sessionExpired: {
        en: "Your session has expired.",
        es: "Su session a expirado.",
    },
    deviceErrorTittle: {
        en: "Profile error",
        es: "Error de perfil",
    },
    deviceErrorDescription: {
        en: "The profile didn't load properly.",
        es: "El perfil no cargo apropiadamente.",
    },
    refresh: {
        en: "Refresh",
        es: "Refrescar",
    },
    checkIfAccountShouldConfirmError: {
        en: "Unable to check account due date.",
        es: "No se puede verificar la fecha de vencimiento de la cuenta.",
    },
    selectCompany: {
        en: "Please select a provider",
        es: "Por favor seleccione un proveedor",
    },
    simAlreadyExist: {
        en: "Sim Already Exist.",
        es: "El sim ya esta en uso.",
    },
    fuelVolumeRequired: {
        en: "Fuel volume is empty",
        es: "Volumen es requerido",
    },
    fuelValueRequired: {
        en: "Fuel value is empty",
        es: "Valor es requerido",
    },
    selectDevice: {
        en: "Unit is required.",
        es: "Unidad es requerida",
    },
    selectRequester: {
        en: "Requester is required",
        es: "Solicitante es requerido",
    },
    selectGasStation: {
        en: "Gas Station is required",
        es: "Gasolinera es requerida",
    },
    invalidPassword: {
        en: "Your current password is incorrect",
        es: "La contraseña actual es incorrecta",
    },
    invalidTankValues: {
        en: "Problem interpreting values",
        es: "Problemas al interpretar los valores",
    },
    emptyDriver: {
        en: "You should select a driver",
        es: "Debes seleccionar un conductor",
    },
    cellPhoneError: {
        en: "The cell phone number is invalid.",
        es: "El número de celular no es válido.",
    },
    cantDeleteCommands: {
        en: "Some commands can't be deleted because they are in use.",
        es: "Algunos comandos no pueden ser eliminados porque están siendo utilizados.",
    },
    cantDeleteEvents: {
        en: "Some events can't be deleted because they are in use.",
        es: "Algunos eventos no pueden ser eliminados porque están siendo utilizados.",
    },
    transportNumberError: {
        en: "The transport number is required",
        es: "El Número de transporte es requerido",
    },
    selectTrailError: {
        en: "The trail is required",
        es: "La ruta es requerida",
    },
    channelError: {
        en: "At least 1 channel is required",
        es: "Al menos 1 canal es requerido",
    },
    registerDuplicated: {
        en: "{register} is duplicated",
        es: "{register} está duplicado",
    },
    followingRegisterWereNotAdded: {
        en: "The following records were not added",
        es: "Los siguientes registros no fueron agregados",
    },
    titleRequired: {
        en: "The title is mandatory",
        es: "El título es obligatorio"
    },
    typeRequired: {
        en: "The type is mandatory",
        es: "El tipo es obligatorio"
    },
    detailsRequired: {
        en: "The description is mandatory",
        es: "La descripción es obligatoria"
    },
    startsAtRequired: {
        en: "The start date is mandatory",
        es: "La fecha de inicio es obligatoria"
    },
    endDateRequired: {
        en: "The end date is mandatory",
        es: "La fecha de terminación es obligatoria"
    },
    carrierRequired: {
        en: "The Carrier is mandatory",
        es: "El Proveedor es obligatorio",
    },
    fieldCannotBeOnlySpaces: {
        en: "The field cannot be only spaces.",
        es: "El campo no puede ser solo espacios"
    },
    phoneNumberRequired: {
        en: "The phone numebr is required",
        es: "El número de teléfono es requerido",
    },
    codeRequired: {
        en: "The code is required",
        es: "El código es requerido",
    },
    invalidFormat: {
        en: "Invalid format",
        es: "Formato inválido",
    },
    unableToSendVerificationCode: {
        en: "Verification code could not be sent",
        es: "No se pudo enviar el código de verificación",
    },
    invalidVerificationCode: {
        en: "Invalid verification code",
        es: "Código de verificación inválido",
    },
    exededRecords: {
        en: "Records in file exceeds the {quantity} allowed",
        es: "Los registros en el archivo exceden los {quantity} permitidos",
    },
    invalidImei: {
        en: "IMEI is not valid",
        es: "IMEI no es valido"
    },
    duplicatedImeiInListError: {
        en: "IMEI is duplicated in this list",
        es: "IMEI esta duplicado en esta lista"
    },
    invalidUnitForPlan: {
        en: "This unit is not available for the selected plan",
        es: "Esta unidad no esta disponible para el plan seleccionado"
    },
    selectPlanError: {
        en: "Please select a subscription plan",
        es: "Porfavor selecciona un plan de suscripcion"
    },
    filterIsRequired: {
        en: "The filter is required",
        es: "El filtro es requerido"
    }
};
exports.default = translations;
